var map = {
	"./loading.svg": "wkYA",
	"./lrc.svg": "1plc",
	"./menu.svg": "7DAd",
	"./no-repeat.svg": "fuqP",
	"./pause.svg": "7O3t",
	"./play.svg": "VT6x",
	"./repeat-all-legacy.svg": "Xf6r",
	"./repeat-all.svg": "+VDx",
	"./repeat-one-legacy.svg": "61o3",
	"./repeat-one.svg": "qKXA",
	"./shuffle.svg": "+7IQ",
	"./skip.svg": "GLpr",
	"./volume-down.svg": "l4+a",
	"./volume-off.svg": "5tJB",
	"./volume-up.svg": "2SYG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZzgZ";


//////////////////
// WEBPACK FOOTER
// ./src/components/aplayer/assets nonrecursive \.svg$
// module id = ZzgZ
// module chunks = 30